<ng-template #OBJ_model_iframe>
	<div class="modal-header tig-modal-header-formbuilder">
		<h1 class="modal-title">{{"oDetail.sEditMode" | translate}}</h1>
		<button type="button" class="btn btn-primary" (click)="closeIframeAndSave()">{{"oDetail.sAcceptChanges" | translate}}</button>
		<button type="button" class="btn btn-secondary" (click)="closeIFrameWithoutSaving()">{{"oDetail.sCancel" | translate}}</button>
	</div>
	<div class="modal-body tig-modal-body-formbuilder">
		<div class="tig-iframe-formbuilder tig-iframe">
			<!-- default is desktop width -->
			<iframe id="{{getIFrameID()}}" width="100%" height="80%" frameborder="0" allowfullscreen [src]="OBJ_field_config._links.iframe.href|safe"></iframe>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<div class="form-group" *ngIf="STR_route_to_self">
	<div class="col-lg-2 control-label"></div>
	<div class="col-lg-8">
		<a href="{{STR_route_to_self}}" target="_blank">{{"oMisc.sFormUrl"|translate}}</a>
	</div>
</div>
<div
		class="form-group tig-form-button" >
	<label class="col-lg-2 control-label" [ngClass]="{'tgi-required': isRequired()}"><!--{{getLabelName()|translate}}-->
		<span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
	<div class="col-lg-8">
		<button #btn type="button" class="tig-button tig-button-formbuilder b-r-xs btn btn-primary" (click)= "openIFrame(btn)">{{getLabelName()|translate}}</button>
		<div class="tig-hint" *ngIf="OBJ_field_config.note">
			<span>{{ OBJ_field_config.note|translate}}</span>
		</div>
		<tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
	</div>
</div>
<div
		*ngIf="OBJ_field_config.value && STR_route_to_self"
		class="form-group tig-form-button">
	<label class="col-lg-2 control-label"></label>
	<div class="col-lg-8">
		<button type="button" class="tig-button tig-button-formbuilder b-r-xs btn btn-primary" (click)="exportFormdata()">{{"oDetail.sExportFormdata"|translate}}</button>
	</div>
</div>
